import { GroupBase, StylesConfig } from 'react-select';
import CreatableSelect from 'react-select/creatable';

interface Props {
  options: string[];
  values: string | string[];
  onChange: (newValue: string | string[]) => void;
  placeholder: string;
  isSearchable?: boolean;
  size?: 'small' | 'base';
  isMulti?: boolean,
  styles?: StylesConfig<{
    label: string;
    value: string;
  }, boolean, GroupBase<{
    label: string;
    value: string;
  }>> | undefined
}

export function CreatableSelectDropDown({
  onChange,
  options,
  placeholder,
  values,
  isMulti = false,
  styles,
  ...props
}: Props) {
  const selectOptions = options.map(o => ({ label: o, value: o }));
  
  return (
    <CreatableSelect
      {...props}
      isMulti={isMulti}
      options={selectOptions as any}
      value={typeof values === "object" ? values.map(o => ({ label: o, value: o })) : values ? { label: values, value: values } : undefined}
      onChange={(newValue) => {
        // @ts-ignore
        if (newValue.length > 0) {
          // @ts-ignore
          onChange(newValue.map((v) => v.value) as string[])
        } else {
          // @ts-ignore
          onChange(newValue.value as string)
        }
      }}
      placeholder={placeholder}
      styles={{
        control: (base) => ({
          ...base,
          borderRadius: 8,
          border: 2,
          borderStyle: "solid",
          borderColor: "rgb(229, 231, 235)",
          boxShadow: "none",
        }),
        placeholder: (base) => ({
          ...base,
          fontSize: 14,
          color: "#999999"
        }),
        container: (base, state) => ({
          ...base,
          fontSize: 16,
          cursor: "pointer",
          padding: "1px 5px",
          borderRadius: 8,
          border: 2,
          borderStyle: "solid",
          borderColor: "rgb(229, 231, 235)",
          boxShadow: state.isFocused ? "0px 0px 0px 2px #B6CFFF25" : "undefined",
          "&:hover": {
            boxShadow: "0px 0px 0px 2px #B6CFFF25",
          },
        }),
        menu: (provided) => ({
          ...provided,
          padding: "0px 4px",
          backgroundColor: "white",
        }),
        option: (provided, state) => ({
          ...provided,
          fontSize: 16,
          borderRadius: "4px",
          "&:hover": {
            backgroundColor: state.isSelected ? "undefined" : "#f3f4f6",
          },
          padding: "6px 10px",
          backgroundColor: state.isSelected ? "F5F7FF" : "white",
          cursor: "pointer",
          color: state.isSelected ? "black" : "black",
        }),
        multiValue: (provided) => ({
          ...provided,
          fontSize: 16,
          padding: "0px 0px 0px 4px",
          borderRadius: 999,
          border: "#B6CFFF",
          background: "#F5F7FF",
          color: "black",
        }),
        multiValueLabel: (styles) => ({
          ...styles,
          color: "#black",
        }),
        ...styles
      }}
    />
  )
}